export default __webpack_public_path__ + "static/media/mockup_curved.9ddded18.svg";